import { Box, Button, Grid, Typography } from "@mui/material";
import {
    EmailFieldRHF,
    EnhancedButtonPrimeReact,
    EnhancedButtonPrimeReactSeverity,
    EnhancedDropDownRHFWithLabel,
    LabelPosition,
    RHookFormPasswordFieldWithLabel,
    RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";
import { FC, useEffect, useState } from "react";

interface IBambooHrInfoSetupFieldsPanel {
    handleImportClick: (tag: string) => void
    importDataPageName: string;

}

export const BambooHrInfoSetupFieldsPanel: FC<
    IBambooHrInfoSetupFieldsPanel
> = ({ handleImportClick, importDataPageName }) => {
    return (
        <>
            <RHookFormTextFieldWithLabel
                label="Company URL"
                id="company_url"
                testId={`key`}
                labelPosition={LabelPosition.Top}
            />
            <RHookFormTextFieldWithLabel
                label="Api Key"
                id="api_key"
                testId={`key`}
                labelPosition={LabelPosition.Top}
            />
            {importDataPageName === "bamboo_hr" ? <EnhancedButtonPrimeReact
                label="Save"
                raised
                severity={EnhancedButtonPrimeReactSeverity.Success}
                // loading={isImporting}
                onClickHandler={() => handleImportClick("bamboo_hr_api_settings")}
            /> :
                <EnhancedButtonPrimeReact
                    label="Save"
                    raised
                    severity={EnhancedButtonPrimeReactSeverity.Success}
                    // loading={isImporting}
                    onClickHandler={() => handleImportClick("namely_api_settings")}
                />
            }
        </>
    );
};